var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '@mui/material/styles/styled';
import ThemeProvider from '../ThemeProvider';
import Box from '../Box';
import Paper from '../Paper';
var Root = styled(Box)(function (_a) {
    var theme = _a.theme, grey = _a.grey, white = _a.white, bgColor = _a.bgColor;
    return __assign(__assign(__assign({ padding: 20 }, (grey && {
        backgroundColor: theme.palette.grey['50']
    })), (white && {
        backgroundColor: '#fff'
    })), (bgColor && {
        backgroundColor: bgColor
    }));
});
var Demo = function (_a) {
    var children = _a.children, white = _a.white, grey = _a.grey, bgColor = _a.bgColor, elevation = _a.elevation, otherProps = __rest(_a, ["children", "white", "grey", "bgColor", "elevation"]);
    return (React.createElement(ThemeProvider, null,
        React.createElement(Paper, { elevation: elevation },
            React.createElement(Root, __assign({ grey: grey, white: white, bgColor: bgColor }, otherProps), children))));
};
Demo.defaultProps = {
    grey: true,
    elevation: 0
};
export default Demo;
